export const PAYMENTS_DASHBOARD = {
    TITLE: "title-input",
    ACCOUNT_SELECTOR: "account-selector",
    START_DATE: "start-date",
    END_DATE: "end-date",
    DATE_PICKER: "date-range-picker",
    SAVE_BUTTON: "date-picker-save-button",
    ERROR_MESSAGE: "error-message",
    PAYMENT_HISTORY_BUTTON: "payment-history-button",
    CARD_ON_FILE_BUTTON: "card-on-file-button",
    DOWNLOAD: "payments-dashboard-download",
};
